import React, { Component } from "react";
import {
  Panel,
  Button,
  Modal,
  Form,
  FormControl,
  FormGroup,
  Col,
  ControlLabel,
  ButtonToolbar,
  Label,
  Popover,
  OverlayTrigger,
  InputGroup,
} from "react-bootstrap";
import FontAwesome from "react-fontawesome";
// import withSizes from 'react-sizes';
import Select from "react-select";
import ReportMobileTable from "./ReportMobileTable";
import { connect } from "react-redux";
import $ from "jquery";
const COLUMN = {
  WORK_DATE: 1,
  WORK_NO: 2,
  CAR_REGISTRATION_NO: 3,
  BRAND: 4,
  MODEL: 5,
  MILEAGE: 6,
  CUSTOMER: 7,
  AMOUNT: 8,
  APPROVED_AMOUNT: 9,
  REMARK: 10,
  FINANCE_REMARK: 11,
  STATUS: 12,
  PAYMENT_STATUS: 13,
  DELETE: 14,
  RESPONSE_PERSON: 15, // 14,
  ALERT_STATUS: 16, // 15,
  THUMBNAIL: 17, // 16,
  DETAIL: 17, // 16,
  FINANCE_STATUS: 19,
};

class ReportWorkTable extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      filter_search_click: false,
      showAddRemark: false,
      isIndex: undefined,
      remark_status: "0",
      filter_query: "",
      filter_type: null,
      pre_filter_type: null,
      filter_lists: [],
      filter_select: null,
      pre_filter_select: { BRAND: null, MODEL: null },
    };
  }

  componentDidMount() {
    if (this.props.onSetIsMobile != undefined)
      this.props.onSetIsMobile(this.props.isMobile);
  }

  onRowWorkClick(workNo, item) {
    if (workNo !== "") {
      if (typeof this.props.onRowWorkClick !== "undefined")
        this.props.onRowWorkClick(workNo, item);
    }
  }

  getRowClass(rowClass, item) {
    const { columnIndex } = this.props;
    let data = item[columnIndex.STATUS],
      cancel = item[columnIndex.DELETE],
      alertStatus = item[columnIndex.ALERT_STATUS];

    if (alertStatus == "1") {
      return "yellow-row";
    } else if (alertStatus == "2") {
      return "red-row";
    }

    if (rowClass !== "") {
      return rowClass;
    }
    if (cancel == "1") {
      return "red-row";
    }

    return "";

    if (data === "0") {
      return "";
    } else if (data === "1") {
      return "orange-row";
    } else if (data === "2") {
      return "blue-row";
    } else if (data === "3") {
      return "green-row";
    } else if (data === "4") {
      return "red-row";
    } else if (data === "5") {
      return "purple-row";
    } else {
      return "";
    }
  }

  clearFilterSearchClick(completeFunc = undefined) {
    this.setState(
      {
        filter_search_click: false,
        filter_query: "",
        filter_type: null,
        pre_filter_type: null,
        filter_lists: [],
        filter_select: null,
        pre_filter_select: { BRAND: null, MODEL: null },
      },
      () => {
        if (completeFunc !== undefined) completeFunc();
      }
    );
  }

  renderWorkCancel(cancel) {
    if (cancel == "1") {
      return (
        <span className="label label-danger">
          {this.props.messages["Cancel"]}
        </span>
      );
    } else {
      return "";
    }
  }

  renderWorkStatus(data, payment_status = 0) {
    let { messages } = this.props;
    if (data === "0") {
      return (
        <span className="label label-default">
          <FontAwesome name="clock-o" />
          {messages["Start"]}
        </span>
      );
    } else if (data === "1") {
      return (
        <span className="label label-warning">
          <FontAwesome name="wrench" />
          {messages["Under Repair"]}
        </span>
      );
    } else if (data === "2") {
      return (
        <span className="label label-primary">
          <FontAwesome name="hourglass-start" />
          {messages["Wait For Delivery"]}
        </span>
      );
    } else if (data === "3") {
      if (payment_status == 0)
        return (
          <span className="label label-success">
            <FontAwesome name="thumbs-o-up" />
            {messages["Work Done"]}
          </span>
        );
      else
        return (
          <span className="label tab-bg-skyblue">
            <FontAwesome name="money" />
            {messages["Charged"]}
          </span>
        );
    } else if (data === "4") {
      return (
        <span className="label label-danger">{messages["Have Problem"]}</span>
      );
    } else if (data === "5") {
      return (
        <span className="label label-purple">
          <FontAwesome name="bitcoin" />
          {messages["Payment"]}
        </span>
      );
    } else if (data === "6") {
      return (
        <span className="label tab-bg-lightgray">
          <FontAwesome name="file-text-o" />
          {messages["Not Yet Quotation"]}
        </span>
      );
    } else if (data === "7") {
      return (
        <span className="label tab-bg-lightyellow">
          <FontAwesome name="wrench" />
          {messages["Job Has Not Been Issued"]}
        </span>
      );
    } else if (data === "8") {
      return (
        <span className="label tab-bg-pink">
          <FontAwesome name="car" />
          {messages["Car Not Parked"]}
        </span>
      );
    } else {
      return (
        <span className="label label-default">
          {messages["Unknown Status"]}
        </span>
      );
    }
  }

  renderResponsiblePerson(item) {
    // let {showWaitForPaymentRemark,showJobDoneRemark} = this.props
    if (item.length >= COLUMN.RESPONSE_PERSON) {
      return (
        <td
          onClick={this.onRowWorkClick.bind(this, item[COLUMN.WORK_NO], item)}
        >
          {item[COLUMN.RESPONSE_PERSON]}
        </td>
      );
    }
    return <td>{this.props.messages["Unknown"]}</td>;
  }

  renderRowDataColumnByType(item, citem) {
    const { columnIndex } = this.props;
    const ditem = item[columnIndex[citem.key]];
    const ctype = citem.column_type;
    if (ctype !== undefined) {
      if (ctype === "html") {
        return <div dangerouslySetInnerHTML={{ __html: ditem }}></div>;
      } else if (ctype === "status") {
        return (
          <div>
            {this.renderWorkStatus(
              item[columnIndex["STATUS"]],
              item[columnIndex["PAYMENT_STATUS"]]
            )}{" "}
            {this.renderWorkCancel(item[columnIndex["DELETE"]])}
          </div>
        );
      } else {
        return <span>{ditem}</span>;
      }
    } else {
      return <span>{ditem}</span>;
    }
  }

  renderRowDataImg(hasImage = false, imageUrl = undefined) {
    const { showImg } = this.props;
    if (hasImage && showImg && imageUrl !== undefined && imageUrl != "") {
      return (
        <img style={{ width: "100%", marginTop: "10px" }} src={imageUrl} />
      );
    } else {
      return "";
    }
  }

  renderRowDataTableTr(item, index, rowClass) {
    let {
      showStatus,
      showAdvanceDate,
      showWaitForPaymentRemark,
      showJobDoneRemark,
      columnTitle,
      columnIndex,
      messages,
    } = this.props;
    let img = item[item.length - 1];
    return (
      <tr key={index} className={this.getRowClass(rowClass, item)}>
        {columnTitle.map((citem, cindex) => {
          if (citem.visible !== undefined && !citem.visible) {
            return "";
          }
          if (citem.column_type == "finance_remark") {
            const finance_icon =
              item[columnIndex.FINANCE_REMARK] !== "" ? (
                ""
              ) : (
                <FontAwesome name="plus" />
              );
            const editClass =
              item[columnIndex.FINANCE_REMARK] !== "" ? "tab-bg-purple" : "";

            return showWaitForPaymentRemark ? (
              <td key={cindex} className="text-left">
                <Label
                  className={editClass}
                  bsSize={"sm"}
                  bsStyle="primary"
                  onClick={() => {
                    this.setState({
                      showAddRemark: true,
                      remark: item[columnIndex["FINANCE_REMARK"]],
                      isIndex: index,
                      remark_status: item[columnIndex["FINANCE_STATUS"]],
                    });
                  }}
                >
                  {finance_icon} {item[columnIndex["FINANCE_REMARK"]]}
                </Label>
              </td>
            ) : (
              ""
            );
          } else if (citem.key == "FINANCE_STATUS") {
            return showWaitForPaymentRemark ? (
              <td key={cindex} className="text-left">
                <Label
                  className={
                    item[columnIndex["FINANCE_STATUS"]] === "1"
                      ? "tab-bg-purple"
                      : ""
                  }
                  bsSize={"sm"}
                  bsStyle="default"
                  onClick={() => {
                    this.setState({
                      showAddRemark: true,
                      remark: item[columnIndex["FINANCE_REMARK"]],
                      isIndex: index,
                      remark_status: item[columnIndex["FINANCE_STATUS"]],
                    });
                  }}
                >
                  {item[columnIndex["FINANCE_STATUS"]] === "1"
                    ? messages["Payment"]
                    : item[columnIndex["FINANCE_STATUS"]] === "2"
                    ? messages["Wait For Price"]
                    : messages["Wait For Payment"]}
                </Label>
              </td>
            ) : (
              ""
            );
          } else if (citem.key == "FINANCE_DATE") {
            return showWaitForPaymentRemark ? (
              <td key={cindex} className="text-center">
                {this.renderRowDataColumnByType(item, citem)}{" "}
              </td>
            ) : (
              ""
            );
          } else if (citem.column_type == "jobdone_remark") {
            const finance_icon =
              item[columnIndex.JOBDONE_REMARK] !== "" ? (
                ""
              ) : (
                <FontAwesome name="plus" />
              );
            const editClass =
              item[columnIndex.JOBDONE_REMARK] !== "" ? "tab-bg-purple" : "";

            return showJobDoneRemark ? (
              <td key={cindex} className="text-left">
                <Label
                  className={editClass}
                  bsSize={"sm"}
                  bsStyle="primary"
                  onClick={() => {
                    this.setState({
                      showAddRemark: true,
                      remark: item[columnIndex["JOBDONE_REMARK"]],
                      isIndex: index,
                      remark_status: item[columnIndex["FINANCE_STATUS"]],
                    });
                  }}
                >
                  {finance_icon} {item[columnIndex["JOBDONE_REMARK"]]}
                </Label>
              </td>
            ) : (
              ""
            );
          } else if (citem.key == "ADVANCE_DATE") {
            return showAdvanceDate ? (
              <td key={cindex} className="text-center">
                {this.renderRowDataColumnByType(item, citem)}{" "}
              </td>
            ) : (
              ""
            );
          } else if (citem.column_type == "status") {
            return (
              <td
                key={cindex}
                style={{ display: showStatus ? "" : "none" }}
                className={
                  citem.class_name !== undefined ? citem.class_name : ""
                }
                onClick={this.onRowWorkClick.bind(
                  this,
                  item[columnIndex["WORK_NO"]],
                  item
                )}
              >
                {this.renderRowDataColumnByType(item, citem)}
                {this.renderRowDataImg(citem.has_image, img)}
              </td>
            );
          }
          return (
            <td
              key={cindex}
              className={citem.class_name !== undefined ? citem.class_name : ""}
              onClick={this.onRowWorkClick.bind(
                this,
                item[columnIndex["WORK_NO"]],
                item
              )}
            >
              {this.renderRowDataColumnByType(item, citem)}
              {this.renderRowDataImg(citem.has_image, img)}
            </td>
          );
        })}
      </tr>
    );
  }

  renderRowDataTableTrOld(item, index, rowClass) {
    let {
      showImg,
      showStatus,
      showWaitForPaymentRemark,
      showJobDoneRemark,
      columnIndex,
    } = this.props;
    let img = item[item.length - 1];
    const finance_icon =
      item[columnIndex.FINANCE_REMARK] !== "" ? (
        ""
      ) : (
        <FontAwesome name="plus" />
      );
    const editClass =
      item[columnIndex.FINANCE_REMARK] !== "" ? "tab-bg-purple" : "";

    return (
      <tr key={index} className={this.getRowClass(rowClass, item)}>
        <td
          className="text-center"
          onClick={this.onRowWorkClick.bind(this, item[COLUMN.WORK_NO], item)}
        >
          {item[COLUMN.WORK_DATE]}
        </td>
        <td
          onClick={this.onRowWorkClick.bind(this, item[COLUMN.WORK_NO], item)}
        >
          {item[COLUMN.WORK_NO]}
        </td>
        <td
          onClick={this.onRowWorkClick.bind(this, item[COLUMN.WORK_NO], item)}
        >
          {item[COLUMN.CAR_REGISTRATION_NO]}
          {img != "" && img != null && showImg ? (
            <img style={{ width: "100%", marginTop: "10px" }} src={img} />
          ) : (
            ""
          )}
        </td>
        <td
          onClick={this.onRowWorkClick.bind(this, item[COLUMN.WORK_NO], item)}
        >
          {item[COLUMN.BRAND]}
        </td>
        <td
          onClick={this.onRowWorkClick.bind(this, item[COLUMN.WORK_NO], item)}
        >
          {item[COLUMN.MODEL]}
        </td>
        <td
          onClick={this.onRowWorkClick.bind(this, item[COLUMN.WORK_NO], item)}
          className="text-right"
        >
          {item[COLUMN.MILEAGE]}
        </td>
        <td
          onClick={this.onRowWorkClick.bind(this, item[COLUMN.WORK_NO], item)}
        >
          {item[COLUMN.CUSTOMER]}
        </td>
        <td
          onClick={this.onRowWorkClick.bind(this, item[COLUMN.WORK_NO], item)}
          className="text-right"
        >
          {item[COLUMN.AMOUNT]}
        </td>
        <td
          onClick={this.onRowWorkClick.bind(this, item[COLUMN.WORK_NO], item)}
          className="text-right"
        >
          {item[COLUMN.APPROVED_AMOUNT]}
        </td>
        <td
          onClick={this.onRowWorkClick.bind(this, item[COLUMN.WORK_NO], item)}
        >
          <div dangerouslySetInnerHTML={{ __html: item[COLUMN.REMARK] }}></div>
        </td>
        {showWaitForPaymentRemark ? (
          <td className="text-left">
            <Label
              className={editClass}
              bsSize={"sm"}
              bsStyle="primary"
              onClick={() => {
                this.setState({
                  showAddRemark: true,
                  remark: item[COLUMN.FINANCE_REMARK],
                  isIndex: index,
                  remark_status: item[COLUMN.FINANCE_STATUS],
                });
              }}
            >
              {finance_icon} {item[COLUMN.FINANCE_REMARK]}
            </Label>
          </td>
        ) : (
          ""
        )}
        {showJobDoneRemark ? (
          <td className="text-left">
            <Label
              className={editClass}
              bsSize={"sm"}
              bsStyle="primary"
              onClick={() => {
                this.setState({
                  showAddRemark: true,
                  remark: item[COLUMN.JOBDONE_REMARK],
                  isIndex: index,
                  remark_status: item[COLUMN.FINANCE_STATUS],
                });
              }}
            >
              {finance_icon} {item[COLUMN.JOBDONE_REMARK]}
            </Label>
          </td>
        ) : (
          ""
        )}
        <td
          onClick={this.onRowWorkClick.bind(this, item[COLUMN.WORK_NO], item)}
          style={{ display: showStatus ? "" : "none" }}
          className="text-center"
        >
          {this.renderWorkStatus(
            item[COLUMN.STATUS],
            item[COLUMN.PAYMENT_STATUS]
          )}{" "}
          {this.renderWorkCancel(item[COLUMN.DELETE])}
        </td>
        {this.renderResponsiblePerson(item)}
      </tr>
    );
  }

  renderRowDetail(item, index) {
    const { columnIndex } = this.props;
    return (
      <Panel style={{ marginBottom: "0px" }}>
        <div
          dangerouslySetInnerHTML={{ __html: item[columnIndex.DETAIL] }}
        ></div>
      </Panel>
    );
  }

  renderHideDetail(item, index, rowClass) {
    return this.renderRowDataTableTr(item, index, rowClass);
  }

  renderShowDetail(item, index, rowClass) {
    // let {showWaitForPaymentRemark} = this.props
    return [
      this.renderRowDataTableTr(item, index, rowClass),
      <tr>
        <td colSpan={13}>{this.renderRowDetail(item, index)}</td>
      </tr>,
    ];
  }

  renderExcelRowData(rowClass) {
    let { dataExcel, columnIndex, showDetail, showWaitForPaymentRemark } =
      this.props;
    //console.log('data',data)
    if (dataExcel.length === 0) {
      return (
        <tr>
          <td
            colSpan={
              showWaitForPaymentRemark
                ? columnIndex.FINANCE_REMARK
                : columnIndex.REMARK
            }
          >
            {this.props.messages["No Data"]}....
          </td>
        </tr>
      );
    }

    return dataExcel.map((item, index) => {
      const content = showDetail
        ? this.renderShowDetail(item, index, rowClass)
        : this.renderHideDetail(item, index, rowClass);
      return content;
    });
  }

  renderRowData(rowClass) {
    let { filter_search_click, filter_select, filter_type } = this.state;
    let {
      data,
      columnIndex,
      showDetail,
      showWaitForPaymentRemark,
      showFilter,
    } = this.props;
    let itemlist = [];
    if (filter_search_click && showFilter) {
      itemlist = JSON.parse(JSON.stringify(data)).reduce(
        (rresult, item, index) => {
          if (item[columnIndex[filter_type]] === filter_select)
            rresult.push(item);
          return rresult;
        },
        []
      );
    } else itemlist = JSON.parse(JSON.stringify(data));
    if (itemlist.length === 0) {
      return (
        <tr>
          <td
            colSpan={
              showWaitForPaymentRemark
                ? columnIndex.FINANCE_REMARK
                : columnIndex.REMARK
            }
          >
            {this.props.messages["No Data"]}....
          </td>
        </tr>
      );
    }
    return itemlist.map((item, index) => {
      const content = showDetail
        ? this.renderShowDetail(item, index, rowClass)
        : this.renderHideDetail(item, index, rowClass);
      return content;
    });
  }

  renderRowDataClaim(rowClass) {
    let { data, columnIndex, showDetail, showWaitForPaymentRemark } =
      this.props;
    let { messages } = this.props;
    if (data.length === 0) {
      return (
        <tr>
          <td
            colSpan={
              showWaitForPaymentRemark
                ? columnIndex.FINANCE_REMARK
                : columnIndex.REMARK
            }
          >
            {messages["No Data"]}....
          </td>
        </tr>
      );
    }
    let preItem = null;
    let newData = [];
    let groupData = {};
    let CLAIM_AT = 0;
    data.map((item, index) => {
      if (
        preItem != null &&
        preItem[columnIndex.CAR_REGISTRATION_NO] ==
          item[columnIndex.CAR_REGISTRATION_NO]
      ) {
        if (groupData[preItem[columnIndex.CAR_REGISTRATION_NO]] === undefined) {
          let header = new Array(preItem.length).fill("");
          CLAIM_AT = preItem.length;
          header[columnIndex.CAR_REGISTRATION_NO] =
            preItem[columnIndex.CAR_REGISTRATION_NO];
          header[columnIndex.BRAND] = preItem[columnIndex.BRAND];
          header[columnIndex.MODEL] = preItem[columnIndex.MODEL];
          newData.push(header);
          //preItem[columnIndex.CAR_REGISTRATION_NO] = 'Claim 1';
          groupData[preItem[columnIndex.CAR_REGISTRATION_NO]] = 0;
        }
      }
      if (preItem != null) {
        let newItem = [...preItem];
        if (groupData[newItem[columnIndex.CAR_REGISTRATION_NO]] !== undefined) {
          groupData[newItem[columnIndex.CAR_REGISTRATION_NO]] += 1;
          newItem[CLAIM_AT] =
            groupData[newItem[columnIndex.CAR_REGISTRATION_NO]];
        }
        newData.push(newItem);
      }
      preItem = item;
    });
    if (preItem != null) newData.push(preItem);
    return newData.map((item, index) => {
      if (
        groupData[item[columnIndex.CAR_REGISTRATION_NO]] !== undefined &&
        item[columnIndex.WORK_NO] != ""
      ) {
        let total = groupData[item[columnIndex.CAR_REGISTRATION_NO]];
        item[columnIndex.CAR_REGISTRATION_NO] =
          messages["Claim"] + " " + (total + 1 - item[CLAIM_AT]) + "/" + total;
        item[columnIndex.BRAND] = "";
        item[columnIndex.MODEL] = "";
      }
      const content = showDetail
        ? this.renderShowDetail(item, index, rowClass)
        : this.renderHideDetail(item, index, rowClass);
      return content;
    });
  }

  onFilterQueryKeyPress(e) {
    if (e.charCode === 13) {
      e.preventDefault();
      this.onFilterQueryClick();
    }
  }

  onFilterQueryChange(e) {
    let { filter_lists } = this.state;
    this.setState({ filter_query: e.target.value });
  }

  onFilterQueryClick() {
    let { filter_query, filter_lists, filter_type } = this.state;
    let { data, columnIndex } = this.props;
    filter_lists = data.reduce((rresult, item, index) => {
      if (
        item[columnIndex[filter_type]].indexOf(filter_query) !== -1 &&
        rresult.indexOf(item[columnIndex[filter_type]]) === -1
      )
        rresult.push(item[columnIndex[filter_type]]);
      return rresult;
    }, []);
    this.setState({ filter_lists: filter_lists });
  }

  onFilterTypeClick(filter_type) {
    let { filter_lists } = this.state;
    let { data, columnIndex } = this.props;
    this.setState({ pre_filter_type: filter_type, filter_query: "" }, () => {
      filter_lists = data.reduce((rresult, item, index) => {
        if (rresult.indexOf(item[columnIndex[filter_type]]) === -1)
          rresult.push(item[columnIndex[filter_type]]);
        return rresult;
      }, []);
      this.setState({ filter_lists: filter_lists });
    });
  }

  // onFilterSelect(selected) { // array
  //   let {filter_select} = this.state
  //   if (selected==='') {
  //     filter_select = []
  //   } else {
  //     if (filter_select.indexOf(selected)===-1)
  //       filter_select.push(selected)
  //     else {
  //       filter_select.splice(filter_select.indexOf(selected),1)
  //     }
  //   }
  //   this.setState({filter_select:filter_select})
  // }

  onFilterSelect(selected) {
    let { pre_filter_select, pre_filter_type } = this.state;
    if (pre_filter_type) {
      if (selected === "") {
        pre_filter_select[pre_filter_type] = null;
      } else {
        if (pre_filter_select[pre_filter_type] !== selected)
          pre_filter_select[pre_filter_type] = selected;
        else {
          pre_filter_select[pre_filter_type] = null;
        }
      }
      this.setState({ pre_filter_select: pre_filter_select });
    }
  }

  onFilterConfirm() {
    let { pre_filter_type, pre_filter_select } = this.state;
    $("body").click();
    this.setState({
      filter_search_click: true,
      filter_type: pre_filter_type,
      filter_select: pre_filter_select[pre_filter_type],
    });
  }

  onFilterHide() {
    $("body").click();
    this.setState({ filter_select: null });
  }

  renderRowHeader() {
    let { filter_query, filter_lists, pre_filter_select, pre_filter_type } =
      this.state;
    const {
      columnTitle,
      showAdvanceDate,
      showStatus,
      showWaitForPaymentRemark,
      showJobDoneRemark,
      showFilter,
    } = this.props;
    let filter_ele = <div></div>;
    let popoverFilterClickRootClose = (
      <Popover id="filter-click" title="ค้นหา">
        <div>
          <div>
            <InputGroup>
              <FormControl
                value={filter_query}
                onChange={this.onFilterQueryChange.bind(this)}
                onKeyPress={this.onFilterQueryKeyPress.bind(this)}
              />
              <InputGroup.Addon
                className="btn"
                onClick={this.onFilterQueryClick.bind(this)}
              >
                <FontAwesome name="search" />
              </InputGroup.Addon>
            </InputGroup>
          </div>
          <div
            style={{
              marginTop: "10px",
              height: filter_lists.length > 6 ? "200px" : "auto",
              overflowY: "auto",
            }}
          >
            <div
              style={{
                cursor: "pointer",
                padding: "5px",
                backgroundColor:
                  pre_filter_select[pre_filter_type] === null
                    ? "#ddd"
                    : "transparent",
              }}
              onClick={this.onFilterSelect.bind(this, "")}
            >
              <FontAwesome name="check" /> (Blanks)
            </div>
            {filter_lists.map((mditem, mdindex) => {
              return (
                <div
                  style={{
                    cursor: "pointer",
                    padding: "5px",
                    backgroundColor:
                      pre_filter_select[pre_filter_type] === mditem
                        ? "#ddd"
                        : "transparent",
                  }}
                  onClick={this.onFilterSelect.bind(this, mditem)}
                  key={mdindex}
                >
                  <FontAwesome name="check" /> {mditem}
                </div>
              );
            })}
          </div>
          <hr />
          <div className="text-right">
            <Button onClick={this.onFilterConfirm.bind(this)} bsStyle="success">
              <FontAwesome name="filter" /> ตกลง
            </Button>{" "}
            <Button onClick={this.onFilterHide.bind(this)}>
              <FontAwesome name="close" /> ปิด
            </Button>
          </div>
        </div>
      </Popover>
    );
    return (
      <tr>
        {columnTitle.map((citem, index) => {
          if (citem.visible !== undefined && !citem.visible) {
            return "";
          }
          if (citem.column_type == "finance_remark") {
            if (showWaitForPaymentRemark) {
              return <th key={index}>{citem.title}</th>;
            } else {
              return "";
            }
          } else if (citem.key == "FINANCE_STATUS") {
            if (showWaitForPaymentRemark) {
              return <th key={index}>{citem.title}</th>;
            } else {
              return "";
            }
          } else if (citem.key == "FINANCE_DATE") {
            if (showWaitForPaymentRemark) {
              return <th key={index}>{citem.title}</th>;
            } else {
              return "";
            }
          } else if (citem.key == "ADVANCE_DATE") {
            if (showAdvanceDate) {
              return <th key={index}>{citem.title}</th>;
            } else {
              return "";
            }
          } else if (citem.column_type == "jobdone_remark") {
            if (showJobDoneRemark) {
              return <th key={index}>{citem.title}</th>;
            } else {
              return "";
            }
          } else if (citem.column_type === "status") {
            if (showStatus) {
              return (
                <th key={index} style={{ display: showStatus ? "" : "none" }}>
                  {this.props.messages["Status"]}
                </th>
              );
            } else {
              return "";
            }
          } else if (citem.key === "BRAND" || citem.key === "MODEL") {
            filter_ele = (
              <OverlayTrigger
                ref="filter_ele"
                trigger="click"
                rootClose
                placement="bottom"
                overlay={popoverFilterClickRootClose}
              >
                <span className="pull-right">
                  <FontAwesome
                    onClick={this.onFilterTypeClick.bind(this, citem.key)}
                    style={{ cursor: "pointer" }}
                    name="filter"
                  />
                </span>
              </OverlayTrigger>
            );
          }
          return (
            <th key={index}>
              {citem.title}
              {(citem.key === "BRAND" || citem.key === "MODEL") && showFilter
                ? filter_ele
                : ""}
            </th>
          );
        })}
      </tr>
    );
  }

  renderTable(rowClass) {
    // let {apiCall,columnTitle,showStatus,showWaitForPaymentRemark} = this.props

    return (
      <div>
        <table className="table table-responsive table-hover table-bordered-solid">
          <thead>{this.renderRowHeader()}</thead>
          <tbody>{this.renderRowData(rowClass)}</tbody>
          <tfoot>{this.renderRowHeader()}</tfoot>
        </table>
      </div>
    );
  }

  renderExcelTable(rowClass) {
    let { showSummary } = this.props;
    return (
      <div style={{ display: "none" }}>
        <table
          id={this.props.tableId}
          className="table table-responsive table-hover table-bordered-solid"
        >
          <thead>{this.renderRowHeader()}</thead>
          <tbody>{this.renderExcelRowData(rowClass)}</tbody>
          <tfoot>
            {this.renderRowHeader()}
            {showSummary && this.renderRowSummary()}
          </tfoot>
        </table>
      </div>
    );
  }

  renderMobileTable() {
    let { data } = this.props;
    let fieldMap = {
      title: COLUMN.CUSTOMER,
      amount: COLUMN.AMOUNT,
      sub_title: COLUMN.CAR_REGISTRATION_NO,
      date: COLUMN.WORK_DATE,
      status: COLUMN.STATUS,
      sub_status: COLUMN.APPROVED_AMOUNT,
      brand: COLUMN.BRAND,
    };

    return (
      <div>
        <ReportMobileTable
          itemlist={data}
          fieldMap={fieldMap}
          renderWorkStatus={this.renderWorkStatus.bind(this)}
          keyIndex={0}
          onRowClick={this.onRowWorkClick.bind(this)}
        />
      </div>
    );
  }

  onRemarkChange(e) {
    this.setState({ remark: e.target.value });
  }

  onRemarkStatusChange(e) {
    this.setState({ remark_status: e.value });
  }

  onRemarkSaveClick() {
    let { remark, isIndex, remark_status } = this.state;
    let index = isIndex;
    this.setState({ showAddRemark: false, isIndex: undefined });
    if (this.props.onUpdateData != undefined) {
      let value =
        this.props.data[index][10] +
        '<span class="label label-default ">' +
        remark +
        "</span>";
      let items = {
        index: index,
        subIndex: 10,
        value: value,
        text: remark,
        status: remark_status,
      };
      this.props.onUpdateData(items);
    }
  }

  renderAddRemark() {
    let { showAddRemark, remark, remark_status } = this.state;
    let { messages } = this.props;
    return (
      <Modal
        show={showAddRemark}
        onHide={() => {
          this.setState({ showAddRemark: false, isIndex: undefined });
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{messages["Add Note"]}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <FormGroup validationState={null} style={{ display: "flex" }}>
              <Col componentClass={ControlLabel} sm={4}>
                {messages["Note"]}
              </Col>
              <Col sm={7}>
                <FormControl
                  value={remark}
                  onChange={this.onRemarkChange.bind(this)}
                />
              </Col>
            </FormGroup>
            <FormGroup validationState={null} style={{ display: "flex" }}>
              <Col componentClass={ControlLabel} sm={4}>
                {messages["Remark Status"]}
              </Col>
              <Col sm={7}>
                <Select
                  placeholder={messages["Select"]}
                  clearable={false}
                  value={remark_status}
                  options={[
                    { label: messages["Wait For Payment"], value: "0" },
                    { label: messages["Payment"], value: "1" },
                    { label: messages["Wait For Price"], value: "2" },
                  ]}
                  onChange={this.onRemarkStatusChange.bind(this)}
                />
              </Col>
            </FormGroup>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar className="pull-right">
            <Button
              onClick={this.onRemarkSaveClick.bind(this)}
              bsStyle={"primary"}
            >
              <FontAwesome name="save" />
              &nbsp;{messages["Save"]}
            </Button>
            <Button
              onClick={() => {
                this.setState({ showAddRemark: false, isIndex: undefined });
              }}
            >
              <FontAwesome name="close" />
              &nbsp;{messages["Close"]}
            </Button>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    let { rowClass, isMobile, type } = this.props;
    if (typeof rowClass !== "undefined") {
      rowClass = "";
    }
    return (
      <div className="display-overflow">
        {isMobile ? this.renderMobileTable() : this.renderTable(rowClass)}
        {type === "print" ? " " : this.renderExcelTable(rowClass)}
        {this.renderAddRemark()}
      </div>
    );
  }
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
});

ReportWorkTable.defaultProps = {
  showAmount: true,
  showStatus: true,
  showWaitForPaymentRemark: false,
  showJobDoneRemark: false,
  showAdvanceDate: false,
  columnTitle: [],
  columnIndex: [],
  tableId: "ReportWork-Export-Excel",
  showFilter: false,
};

export default connect(
  (state) => ({ messages: state.message.view.report.ReportWorkTable }),
  null,
  null,
  { withRef: true },
  mapSizesToProps
)(ReportWorkTable);



// WEBPACK FOOTER //
// ./src/view/report/ReportWorkTable.js